import { IonButton } from "@ionic/react";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import {
  CompleteTest,
  CompleteTestPhase,
} from "../../services/AssessmentsService";
import { Assessment } from "../../models/AssessmentRelated/Assessment";
import { getAngleValues } from "../../utils/mobile-bridge";
import { useRecoilState } from "recoil";
import {
  PatientState,
  currentAssessmentState,
  defaultAssessment,
} from "../../data/atoms";
import { ASSESSMENT_STATUSES } from "../../../src/movenet/params";
import {
  convertDOBintoAge,
  formatAMPM,
  getCurrentDay,
  getLocalStringDate,
} from "../../utils/sharedFunction";
import { v4 as uuidv4 } from "uuid";

interface Props {
  setFinishIncompleteTest: Function;
  setShowFinishIncompleteTestModal: Function;
  onChildClick: Function;
}
const FinishIncompleteTestModal: React.FC<Props> = ({
  setFinishIncompleteTest,
  setShowFinishIncompleteTestModal,
  onChildClick,
}) => {
  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState
  );

  let history = useHistory();

  const [patientAge, setpatientAge] = useState(0);
  const [date, setDate] = useState(getCurrentDay());
  const [time, setTime] = useState(formatAMPM(new Date()));
  const [patientInfo, setPatientInfo] = useRecoilState(PatientState);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // const ReDoTest = () => {
  //   setFinishIncompleteTest(false);
  //   onChildClick("Redo");
  // };

  const goBack = () => {
    setFinishIncompleteTest(false);
    history.push("/patient-page");
  };

  const ViewResult = () => {
    setIsSubmitted(true);

    let localtime = new Date(
      new Date().setHours(
        new Date().getHours() - new Date().getTimezoneOffset() / 60
      )
    ).toISOString();

    CompleteTestPhase({
      TestId: currentAssessment.testId,
      AdmissionDateUTC: localtime,
      LocalDateTime: localtime,
      UTCDateTime: localtime,
      StartTime: localtime,
      StartTimeUTC: localtime,
      EndTime: localtime,
      EndTimeUTC: localtime,
      TestJson: currentAssessment.testJson,
    })
      .then((result: any) => {
        setcurrentAssessmentState((prevState: Assessment) => ({
          ...prevState,
          phaseId: result.data.id,
        }));

        CompleteTest({
          TestId: currentAssessment?.testId,
          VisitId: currentAssessment?.visitId,
          //  IsInComplete: currentAssessment.testId,
          PatientId: localStorage.getItem("patientServerID"),
          // TestLookupId:  TestType.gait,
          TestLookupId: currentAssessment.assessmentType
            ? currentAssessment.assessmentType
            : 0,
          MasterTestId: currentAssessment.masterTestId,
          PhaseId: result.data.id,
        })
          .then(async (res: any) => {
            if (res.data.responseCode == 1) {
              let summaryDetail = {
                date: date,
                dateFormat: getLocalStringDate(),
                time: time,
              };
              setpatientAge(convertDOBintoAge(new Date(patientInfo?.dob)));
              let assessmentSummaryArray = JSON.parse(
                localStorage.getItem("summaryDetail") || "[]"
              );
              let getJSONSummary = JSON.parse(
                localStorage.getItem("Assesment Summary")!
              );
              let assessmentID = uuidv4();
              let patientServerID = localStorage.getItem("patientServerID")
                ? localStorage.getItem("patientServerID")
                : "000";
              let patientName = localStorage.getItem("patientName")
                ? localStorage.getItem("patientName")!
                : "Name Required";
              getJSONSummary = {
                assessmentID: assessmentID,
                patientServerID: patientServerID,
                patientName: patientName,
                patientAge: patientAge,
                ...summaryDetail,
                ...getJSONSummary,
              };
              assessmentSummaryArray.push(getJSONSummary);
              localStorage.setItem(
                "summaryDetail",
                JSON.stringify(assessmentSummaryArray)
              );
              localStorage.setItem(
                "selectedAssesment",
                JSON.stringify(assessmentID)
              );
              setTimeout(() => {
                history.replace("/patient-assessment-summary", {
                  pageHeaderText: "Full Visit Summary",
                  isAssessmentCompleted: true,
                });
              }, 200);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const ExitnDiscard = () => {
    setFinishIncompleteTest(false);
    setShowFinishIncompleteTestModal(false);
    ASSESSMENT_STATUSES.incomplete_test = true;
    // history.replace("/phone-height-requirement");
    history.push("/patient-page");
  };

  return (
    <>
      <div className="finish-incomplete-test-modal">
        {/* <div className="d-flex justify-content-end">
          <svg
            onClick={() => {
              setFinishIncompleteTest(false);
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.9999 20.909L2.90845 2.90918M21 2.90918L2.90845 20.9091"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div> */}
        <div className="align-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="130"
            height="130"
            viewBox="0 0 130 130"
            fill="none"
          >
            <path
              d="M32.4261 121.249C42.3246 126.981 53.5606 130 64.9991 130C69.8315 130 73.749 126.082 73.749 121.25C73.749 116.418 69.8315 112.5 64.9991 112.5L64.9991 112.45C56.649 112.45 48.4467 110.246 41.2208 106.062C33.9948 101.877 28.0011 95.86 23.845 88.6175C19.6888 81.3751 17.5175 73.1642 17.5502 64.814C17.5829 56.4638 19.8186 48.2702 24.0314 41.0606C28.2442 33.851 34.2849 27.8808 41.5434 23.753C48.8019 19.6252 57.0212 17.486 65.371 17.5515C73.7209 17.6169 81.9056 19.8847 89.0985 24.1258C95.759 28.0529 101.351 33.5431 105.397 40.1103C106.507 43.6678 109.827 46.2499 113.75 46.2499C118.583 46.2499 122.5 42.3324 122.5 37.4999C122.5 35.9474 122.096 34.4893 121.387 33.2252L121.626 33.0901C116.011 23.1247 107.865 14.8176 98.012 9.00794C88.1587 3.19823 76.9468 0.0916642 65.5086 0.00200454C54.0705 -0.0876704 42.8112 2.84274 32.868 8.49724C22.9248 14.1517 14.6499 22.3301 8.87891 32.2063C3.10797 42.0824 0.045434 53.3066 0.000604647 64.7452C-0.0442399 76.1838 2.93023 87.4317 8.62358 97.3528C14.3169 107.274 22.5275 115.517 32.4261 121.249Z"
              fill="#802392"
            />
            <path
              d="M87.7565 112.814C84.2489 114.713 82.9447 119.096 84.8437 122.604C86.7427 126.111 91.1257 127.415 94.6333 125.516C97.2136 124.12 99.6907 122.548 102.051 120.817C105.268 118.458 105.963 113.938 103.604 110.722C101.245 107.505 96.7257 106.81 93.5091 109.168C91.672 110.516 89.7506 111.734 87.7565 112.814Z"
              fill="#802392"
            />
            <path
              d="M107.323 94.068C105.242 97.4709 106.313 101.917 109.716 103.998C113.119 106.079 117.564 105.007 119.645 101.604C121.151 99.1427 122.51 96.5742 123.711 93.9121C125.352 90.2764 123.735 85.999 120.099 84.3583C116.463 82.7176 112.186 84.3349 110.545 87.9706C109.592 90.0841 108.514 92.1201 107.323 94.068Z"
              fill="#802392"
            />
            <path
              d="M115.453 67.9087C115.218 71.8906 118.256 75.309 122.237 75.5441C126.219 75.7792 129.638 72.7418 129.873 68.7599C129.957 67.3281 130 65.8851 130 64.4324C130 62.9797 129.957 61.5367 129.873 60.1048C129.638 56.123 126.219 53.0856 122.237 53.3207C118.256 53.5557 115.218 56.9742 115.453 60.9561C115.521 62.1047 115.556 63.2638 115.556 64.4324C115.556 65.601 115.521 66.7601 115.453 67.9087Z"
              fill="#802392"
            />
          </svg>
          <h1 className="assesment-modal-label">Incomplete Test</h1>
          <p className="calibration-modal-desc">
            This test is incomplete. <br></br> Please exit and discard to try
            again.
          </p>
          {/* <p className="assesment-modal-desc mt-0">
            Please exit and discard to try again.
          </p> */}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "30px",
            margin: "20px",
          }}
        >
          {/* id: the remote's NEXT presses this for a stopped single-phase assessment (assessment-page.tsx) */}
          <IonButton
            id="btnIncompleteTestExitDiscard"
            className="blue-outline-btn"
            onClick={() => {
              ExitnDiscard();
            }}
            placeholder={undefined}
          >
            Exit & Discard
          </IonButton>
          <IonButton
            className="blue-btn"
            disabled={isSubmitted}
            onClick={() => {
              ViewResult();
            }}
            placeholder={undefined}
          >
            Exit & Save
          </IonButton>
        </div>
      </div>
    </>
  );
};
export default FinishIncompleteTestModal;
